import { useInfiniteQuery, UseInfiniteQueryOptions } from "react-query";

import { fetchMessages } from "modules/chat/api/messages";

import { ThreadMessagesResponse } from "modules/chat/types/res";

type ThreadMessagesQueryKey = [
  string,
  {
    threadId: string;
    before?: Date;
  }
];

export const THREAD_MESSAGES_QUERY_KEY = "/memory/threads/:threadId/messages";

export const getThreadMessagesQueryKey = (params: {
  threadId: string;
  before?: Date;
}): ThreadMessagesQueryKey => [THREAD_MESSAGES_QUERY_KEY, params];

export const useThreadMessagesQuery = (
  params: {
    threadId: string;
    before?: Date;
  },
  options: UseInfiniteQueryOptions<
    ThreadMessagesResponse,
    unknown,
    ThreadMessagesResponse,
    ThreadMessagesResponse,
    ThreadMessagesQueryKey
  > = {}
) => {
  return useInfiniteQuery({
    queryKey: getThreadMessagesQueryKey(params),
    keepPreviousData: true,
    enabled: !!params.threadId,
    cacheTime: Infinity,
    staleTime: Infinity,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    queryFn: ({ pageParam = 0, queryKey: [, params] }) =>
      fetchMessages({ ...params, page: pageParam, perPage: 4 }),
    getNextPageParam: currentPage => {
      if (currentPage) {
        return currentPage.hasMore ? currentPage.page + 1 : undefined;
      }

      return undefined;
    },
    ...options
  });
};
